import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=53931be4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53931be4"]])

export default __exports__